import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { Icon, message } from 'antd';
import FontSideBar from '../../FontSideBar';
import { fetchChart, getChartPayload, getUniqueRgb } from './chartHelper';
import { ChartColorPicker } from './chartColorPicker';
import { CHART_TRANSLATION } from './translationValues';
import { ChartColorPickerSection } from './styles';
import { deepCopy } from '../../../../utils/javascript';
import { barChartTypes } from './chartConstants';

const ChartToolbar = ({ element, updateComplexElementDetails, t }) => {
  const { contents, uuid, style } = element;
  const { fontFamily, dataSource, colorPalette, type, seriesList } = contents;
  const { isVariable } = style;
  const [fontListVisible, toggleFontList] = useState(false);

  const isBarChart = barChartTypes.includes(type);

  const onFontClick = useCallback(e => {
    toggleFontList(true);
  }, []);

  const closeFontList = useCallback(() => {
    toggleFontList(false);
  }, []);

  const updateChartDetails = async (updatedValue, key) => {
    let copiedContent;
    if (key) {
      copiedContent = deepCopy(element).contents;
      copiedContent[key] = updatedValue;
    } else {
      copiedContent = updatedValue;
    }
    const payload = getChartPayload(copiedContent, isVariable);
    try {
      const data = await fetchChart(payload);
      copiedContent.dataUrl = `data:image/png;base64, ${data.base64ImageBytes}`;
      copiedContent.dataRequest = payload;
      updateComplexElementDetails(uuid, copiedContent, 'contents');
    } catch (error) {
      message.error(
        t(CHART_TRANSLATION.CHART_UPDATE_ERROR.key, CHART_TRANSLATION.CHART_UPDATE_ERROR.value),
      );
    }
  };

  const setFontFamily = async value => {
    updateChartDetails(value, 'fontFamily');
  };

  const setPieFontColor = ({ rgb }, oldValue) => {
    const uptDataSource = deepCopy(dataSource).map(item => {
      if (item.color.toString() === oldValue.toString()) {
        item.color = [rgb.r, rgb.g, rgb.b];
      }
      return item;
    });
    updateChartDetails(uptDataSource, 'dataSource');
  };

  const setBarFontColor = ({ rgb }, oldValue) => {
    const tempSeriesList = deepCopy(seriesList).map(item => {
      if (item.color.toString() === oldValue.toString()) {
        item.color = [rgb.r, rgb.g, rgb.b];
      }
      return item;
    });
    updateChartDetails(tempSeriesList, 'seriesList');
  };

  const setAdditionalFontColor = ({ rgb }, oldValue) => {
    const colorIndex = colorPalette.findIndex(color => color.toString() === oldValue.toString());
    const updatedColors = [...colorPalette];
    updatedColors[colorIndex] = [rgb.r, rgb.g, rgb.b];
    updateChartDetails(updatedColors, 'colorPalette');
  };

  const addAdditionalColor = () => {    
    const updatedColors =  [...colorPalette, getUniqueRgb(colorPalette)]; 
    updateChartDetails(updatedColors, 'colorPalette');
  };

  const removeColorPalette=(i)=>{
    const updatedColors = colorPalette.filter((_, index) => index !== i);
    updateChartDetails(updatedColors, 'colorPalette');
  }

  return (
    <>
      <div
        class="ql-font"
        onClick={onFontClick}
        style={{
          height: '32px',
          width: '150px',
          color: 'white',
          border: '1px solid white',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          padding: '8px',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        <span
          style={{
            width: '170px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#fff',
            fontSize: '14px',
            textAlign: 'center',
          }}
        >
          {fontFamily}{' '}
        </span>
      </div>
      <ChartColorPickerSection>
        {isBarChart &&
          seriesList.map(({ color }) => {
            return <ChartColorPicker fontColor={color} onColorChange={setBarFontColor} deleteColorPicker= {false}/>;
          })}
        {!isBarChart &&
          dataSource.map(({ color }) => {
            return <ChartColorPicker fontColor={color} onColorChange={setPieFontColor} deleteColorPicker= {false}/>;
          })}
        {colorPalette.map((color, index) => {
          return <ChartColorPicker fontColor={color} key={index} index={index} onColorChange={setAdditionalFontColor} removeColorPalette={removeColorPalette} deleteColorPicker/>;
        })}
        <Icon type="plus" onClick={addAdditionalColor} />
      </ChartColorPickerSection>
      {fontListVisible && (
        <FontSideBar
          itemUUID={uuid}
          setFontChange={setFontFamily}
          fontFamily={fontFamily}
          isToolBarVisible={fontListVisible}
          closeFontList={closeFontList}
          isAbsolute={true}
        />
      )}
    </>
  );
};

export const ChartSettingsToolbar = props => {
  const documentEditorElement = document.getElementById('document-editor-toolbar');
  if (!documentEditorElement) {
    return <></>;
  }
  return ReactDOM.createPortal(<ChartToolbar {...props} />, documentEditorElement);
};
